export const analyticsFormEvents = {
  formSubmission: 'form_submission',
  formVisit: 'form_visit',
  privateFormVisit: 'private_form_visit',
  publicFormVisit: 'public_form_visit'
};

export const publicFormEvents = {
  publicFormSubmission: 'public_form_submission'
};

export const FORM_SUBMISSION = 'form_submission';
export const PUBLIC_FORM_SUBMISSION = 'public_form_submission';
export const PRIVATE_FORM_SUBMISSION = 'private_form_submission';
export const PUBLIC_FORM_VISIT = 'public_form_visit';
export const PRIVATE_FORM_VISIT = 'private_form_visit';
export const FORM_VISIT = 'form_visit';

export const analyticsFormTypes = {
  publicEmbed: 'public_embed',
  privateEmbed: 'private_embed'
};
